module.exports = __webpack_public_path__ + "montserrat-extralightitalic-webfont.06806be00dc670127acb.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-extralightitalic-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-extralightitalic-webfont.woff
// module chunks = styles